interface ErrorConfig {
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  showModal?: boolean;
}

interface BaseInfoError {
  response?: {
    status?: number;
    data?: {
      internalCode?: string;
    };
  };
  undefined?: undefined;
}

/**
 * Manipula erros específicos da API e retorna configuração para Alert
 * @param error - Objeto de erro da API
 * @param context - Contexto adicional para personalizar mensagens
 * @returns Configuração do alert com tipo e mensagem
 */
export const handleApiError = (error: BaseInfoError): ErrorConfig => {
  // Caso 1: Erro é undefined
  if (error === undefined) {
    return {
      type: 'error',
      message: 'Proposta inexistente na Sicred',
    };
  }

  // Caso 2: Existe error.response
  else {
    const status = error.response?.status;
    const errorCode = error.response?.data?.internalCode;

    switch (status) {
      case 400:
        if (errorCode === 'PL400VAL') {
          return {
            type: 'error',
            message: 'Proposta já registrada',
            showModal: true,
          };
        }
        break;

      case 500:
      case 502:
      case 503:
      case 504:
        return {
          type: 'error',
          message: 'Erro interno do servidor. Tente novamente em alguns instantes.',
        };

      default:
        break;
    }
    // Caso padrão para quando existe response
    return {
      type: 'error',
      message: 'Ocorreu um erro ao buscar a proposta. Tente novamente.',
    };
  }
};

/**
 * Versão específica para erros de proposta
 */
export const handleProposalError = (error: BaseInfoError): ErrorConfig => {
  return handleApiError(error);
};
